import React from 'react'

import { Form } from '_zari/core'

const FlagBolsaFormGroup = ({ value, onChange }) => {
  return (
    <Form.Checkbox
      name="checkSeleccionar"
      checked={value}
      onChange={onChange}
      id='checkbox-flagSeleccionarTodo'
      label='Seleccionar Todos'
    />
  )
}

export default FlagBolsaFormGroup
